"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TransmuteCollection = require("./TransmuteCollection");

var _immutable = require("immutable");

var empty = function empty() {
  return undefined;
};

_TransmuteCollection.get.implement(null, empty);

_TransmuteCollection.get.implement(undefined, empty);

_TransmuteCollection.get.implementInherited(_immutable.Iterable, function (key, subject) {
  return subject.get(key);
});

var _default = _TransmuteCollection.get;
exports.default = _default;
module.exports = exports.default;